import { useWalletStateContext } from 'shared/contexts/wallet-state-context'

/**
 * Returns wallet state and actions (connect, switch chain, etc.).
 * In EVM mode uses WagmiProvider; in Solana mode uses Solana WalletProvider.
 * The correct provider is mounted at the app root based on VITE_CHAIN_TYPE.
 */
export const useWallet = () => {
  return useWalletStateContext()
}
